var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPoiClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 35,
    viewBox: "0 0 37 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37.007,
    height: 35.007,
    rx: 17.5035,
    fill: "#C6DFF2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5629 12.5629C26.1488 11.977 26.1488 11.0254 25.5629 10.4395C24.977 9.85352 24.0254 9.85352 23.4395 10.4395L18.5035 15.3801L13.5629 10.4441C12.977 9.8582 12.0254 9.8582 11.4395 10.4441C10.8535 11.0301 10.8535 11.9816 11.4395 12.5676L16.3801 17.5035L11.4441 22.4441C10.8582 23.0301 10.8582 23.9816 11.4441 24.5676C12.0301 25.1535 12.9816 25.1535 13.5676 24.5676L18.5035 19.627L23.4441 24.5629C24.0301 25.1488 24.9816 25.1488 25.5676 24.5629C26.1535 23.977 26.1535 23.0254 25.5676 22.4395L20.627 17.5035L25.5629 12.5629Z",
    fill: "#004E98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoiClose);
export default __webpack_public_path__ + "static/media/poi-close.3017c9cd9360c2ffd0109ac5d073d116.svg";
export { ForwardRef as ReactComponent };